import React from 'react';
import './Customers.css';
import pdt1 from '../../img/pdf/Pooja Product Catalogue (1).pdf';
import img1 from '../../img/pdf img/Pooja Product Catalogue_page-0001.jpg';

import pdt2 from '../../img/pdf/Nilkanth Product Catalogue.pdf';
import img2 from '../../img/pdf img/Screenshot 2024-08-20 115048.png';

import pdt3 from '../../img/pdf/Pooja Plastics House hold Catalogue (1).pdf';
import img3 from '../../img/pdf img/Screenshot 2024-08-20 115154.png';

function Customers() {
  const handleImageClick = (pdfUrl) => {
    window.open(pdfUrl, '_blank');
  };

  return (
    <div className='main_section'>
      <div className='uper'>
        <h1>CATALOGUE</h1>
      </div>
      <div className="images-section">
        <img 
          src={img1} 
          alt="Pooja Product Catalogue"
          onClick={() => handleImageClick(pdt1)} 
        />
        <img 
          src={img2} 
          alt="Nilkanth Product Catalogue"
          onClick={() => handleImageClick(pdt2)} 
        />
        <img 
          src={img3} 
          alt="Pooja Plastics Household Catalogue"
          onClick={() => handleImageClick(pdt3)} 
        />
      </div>
    </div>
  );
}

export default Customers;
